import React, { FC } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { Grid, TextField } from '@mui/material';
import { SCUIButton } from '../../../atomic/atoms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { LocalizationManagementCommand } from '../../../services/command';
import { LOC, locCls } from '../localizationManagement.classes';

interface IProps {
    selectedRow?: any;
    onCloseMenu?: any;
    refresh?: any;
    cultureList?: any;
    applicationList?: any;
}
export const SCUIAddLocalizationDrawerContent: FC<IProps> = ({
    onCloseMenu,
    refresh,
    cultureList,
    applicationList,
}) => {
    const handleChangeApplication = (event: any) => {
        setApplication(event.target.value);
    };
    const handleChangeCulture = (event: any) => {
        setCulture(event.target.value);
    };
    const handleChangeKeyword = (event: any) => {
        setKeyword(event.target.value);
    };
    const handleChangeKeywords = (event: any) => {
        setKeywordValue(event.target.value);
    };

    const CreateLocalizationItem = async () => {
        let params: any = {};
        let myArray: any = [];
        myArray.push(application);
        params.culture = culture;
        params.keyWord = keyword;
        params.value = keywordValue;
        params.applicationIds = myArray;
        LocalizationManagementCommand.AddLocalizationManagement(params)
            .then(() => {
                Swal.fire(t('general.added'), ' ', 'success');
                refresh();
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    const { t } = useTranslation();
    const [application, setApplication] = React.useState([]);
    const [keyword, setKeyword] = React.useState();
    const [keywordValue, setKeywordValue] = React.useState();
    const [culture, setCulture] = React.useState();

    return (
        <Grid className={locCls('designCollectiveselectedRowGrid', LOC.addDrawerRoot)}>
            <Grid container sx={{ paddingTop: '2rem' }}>
                <Grid
                    className={LOC.addDrawerTitleRow}
                    sx={{ paddingLeft: '3rem' }}
                    size={{
                        md: 6,
                        xs: 6,
                        lg: 11,
                    }}
                >
                    <h1 className={locCls('headtxt', LOC.addDrawerTitle)}>{'Lokalizasyon Ekleme'}</h1>
                </Grid>
                <Grid
                    size={{
                        md: 1,
                        xs: 1,
                        lg: 1,
                    }}
                >
                    <CloseIcon className={locCls('svg_icons', LOC.inputIconAddDrawerClose)} onClick={onCloseMenu} />
                </Grid>
            </Grid>
            <Grid container sx={{ padding: '3rem' }}>
                <br />
                <Grid
                    className={LOC.addDrawerAppField}
                    style={{ marginTop: '1rem' }}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <InputLabel id="demo-simple-select-label">{t('general.app')}</InputLabel>
                    <Select
                        className={LOC.inputSelectAddApp}
                        label={t('general.app')}
                        labelId="labelApp"
                        id="parentMenuLabel"
                        fullWidth
                        onChange={handleChangeApplication}
                    >
                        {applicationList &&
                            applicationList.map((app: any) => (
                                <MenuItem key={app.applicationId} id={app.applicationId} value={app.applicationId}>
                                    {app.applicationName}
                                </MenuItem>
                            ))}
                    </Select>
                </Grid>
                <Grid
                    className={LOC.addDrawerCultureField}
                    style={{ marginTop: '1rem' }}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <InputLabel id="demo-simple-select-label">{t('general.selectCulture')}</InputLabel>
                    <Select
                        className={LOC.inputSelectAddCulture}
                        label={t('general.selectCulture')}
                        labelId="labelSelectCulture"
                        id="parentMenuLabel"
                        fullWidth
                        onChange={handleChangeCulture}
                    >
                        {cultureList &&
                            cultureList.map((culture: any) => (
                                <MenuItem key={culture.id} id={culture.id} value={culture.code}>
                                    {culture.code}
                                </MenuItem>
                            ))}
                    </Select>
                </Grid>
                <Grid
                    className={LOC.addDrawerKeywordField}
                    style={{ marginTop: '2rem' }}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <TextField
                        className={LOC.inputTextAddKeyword}
                        id="keywordValue"
                        type="text"
                        label={t('general.keyword')}
                        fullWidth
                        onChange={handleChangeKeyword}
                    />
                </Grid>
                <Grid
                    className={LOC.addDrawerKeywordsField}
                    style={{ marginTop: '2rem' }}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <TextField
                        className={LOC.inputTextAddKeywords}
                        id="keyword"
                        type="text"
                        label={t('general.keywords')}
                        fullWidth
                        onChange={handleChangeKeywords}
                    />
                </Grid>

                <Grid
                    className={LOC.addDrawerFooter}
                    container
                    justifyContent={'flex-end'}
                    sx={{ marginTop: '2rem' }}
                    size={{
                        xs: 12,
                        sm: 12,
                    }}
                >
                    {
                        <SCUIButton
                            className={LOC.inputButtonAddSave}
                            text={'Kaydet'}
                            type="primary"
                            sizeType="fixed"
                            size={'l'}
                            onClick={() => CreateLocalizationItem()}
                        ></SCUIButton>
                    }
                </Grid>
            </Grid>
        </Grid>
    );
};
